import { ShiftDifferentialType } from '~/types/hlx/enums';
import { JobListing } from '~/types/hlx/jobListing';
import { emptyCallShiftDetailsForm, SHIFT_DIFF_TYPE_OPTIONS } from './constants';
import { OnCallShiftDetailsFormValues } from './types';

// Hydration loop: listing.detail -> mounted form defaults -> allowlisted PATCH ->
// parent listing.detail -> remount -> hydrated defaults. Keep both transforms aligned.
export const transformApiToOnCallShiftDetailsForm = (
  listing: JobListing
): OnCallShiftDetailsFormValues => {
  const callShiftDiffTypeValue =
    listing.detail?.callShiftDiffType ??
    listing.detail?.shiftDiffType ??
    ShiftDifferentialType.INCR_HOURLY_RATE;
  const callShiftDiffTypeOption =
    SHIFT_DIFF_TYPE_OPTIONS.find((option) => option.value === callShiftDiffTypeValue) ||
    SHIFT_DIFF_TYPE_OPTIONS[0];

  return {
    ...emptyCallShiftDetailsForm,
    ...listing.detail,
    id: listing.detail?.id,
    jobListingId: listing.id,
    callShiftDiffType: callShiftDiffTypeOption,
  };
};

export const transformOnCallShiftDetailsFormToApi = (formValues: OnCallShiftDetailsFormValues) => {
  const {
    id,
    jobListingId,
    numDayCallShifts,
    numEveCallShifts,
    numNightCallShifts,
    numOfWeDayCallShifts,
    numOfWeEveCallShifts,
    numOfWeNightCallShifts,
    numHolDayCallShifts,
    numHolEveCallShifts,
    numHolNightCallShifts,
    callShiftDiffType,
    dayCallShiftRateDiff,
    eveCallShiftRateDiff,
    nightCallShiftRateDiff,
    weDayCallShiftRateDiff,
    weEveCallShiftRateDiff,
    weNightCallShiftRateDiff,
    holDayCallShiftRateDiff,
    holEveCallShiftRateDiff,
    holNightCallShiftRateDiff,
  } = formValues;

  return JSON.stringify({
    id,
    jobListingId,
    numDayCallShifts,
    numEveCallShifts,
    numNightCallShifts,
    numOfWeDayCallShifts,
    numOfWeEveCallShifts,
    numOfWeNightCallShifts,
    numHolDayCallShifts,
    numHolEveCallShifts,
    numHolNightCallShifts,
    callShiftDiffType: callShiftDiffType.value,
    dayCallShiftRateDiff,
    eveCallShiftRateDiff,
    nightCallShiftRateDiff,
    weDayCallShiftRateDiff,
    weEveCallShiftRateDiff,
    weNightCallShiftRateDiff,
    holDayCallShiftRateDiff,
    holEveCallShiftRateDiff,
    holNightCallShiftRateDiff,
  });
};
